import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["select", "preview"]
  static colors = Object.freeze({
    'dark_blue': '#3A3ADC',
    'purple': '#AC3ADC',
    'violet': '#9d2e91',
    'red': '#e42c3b',
    'green': '#5bb054',
    'orange': '#eda739',
    'blue': '#26a3dc',
    'turquoise': '#39edc3',
    'yellow': '#fcba03',
    'grey': '#b8b6b6'
  })

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const hexColor = this.selectTarget.value

    if (hexColor) {
      this.previewTarget.style.backgroundColor = hexColor
      this.previewTarget.style.display = "inline-block"
    } else {
      this.previewTarget.style.display = "none"
    }
  }
}
